module.exports = __webpack_public_path__ + "media/images/lp/1/history-5sp-00b45cff5b4ce5b19e4d4981973ea35f.jpg";